module.exports = __webpack_public_path__ + "static/media/arrow-left.7460f336.svg";